<div>
    <div
        style="
            width: 100% !important;
            font-size: 24px !important;
            height: 3.5rem !important;
            line-height: 3.3rem !important;
            font-weight: bold;
            text-align: center;
            text-transform: uppercase;
            font-size: 16px;
        "
        [ngClass]="{
            'badge-success':
                statut === 'actif' || statut === 'actif' || statut === 'fiable',
            'badge-warning': statut === 'en-cours',
            'badge-dark': statut === 'suspendu',
            'badge-danger': statut === 'resilié' || statut === 'non-fiable'
        }"
    >
        {{ statut }}
    </div>
</div>
